<div class="p-4 settings-page">
  <h4 class="mb-3">Configurações globais (WhatsApp)</h4>

  <form [formGroup]="form" class="card p-3 mb-4">
    <div class="mb-3">
      <label class="form-label">Imagem do WAHA</label>
      <div class="input-group">
        <select class="form-select waha-image-source" formControlName="wahaImageSource">
          <option *ngFor="let source of wahaImageSources()" [value]="source">{{ source }}</option>
        </select>
        <input type="text" class="form-control" formControlName="wahaImageTag" placeholder="latest" />
      </div>
      <div class="text-danger" *ngIf="form.get('wahaImageTag')?.touched && form.get('wahaImageTag')?.hasError('required')">
        Campo obrigatório
      </div>
    </div>

    <div class="mb-3">
      <label class="form-label">Nível mínimo de log do WAHA</label>
      <select class="form-select" formControlName="wahaLogLevel">
        <option *ngFor="let level of logLevels" [value]="level">{{ level }}</option>
      </select>
    </div>

    <div class="mb-3">
      <label class="form-label">Imagem do Nibo WAHA</label>
      <div class="input-group">
        <span class="input-group-text">{{ niboWahaImagePrefix }}</span>
        <input type="text" class="form-control" formControlName="niboWahaImageTag" placeholder="1.2.3" />
      </div>
      <div class="text-danger" *ngIf="form.get('niboWahaImageTag')?.touched && form.get('niboWahaImageTag')?.hasError('required')">
        Campo obrigatório
      </div>
    </div>

    <div class="mb-3">
      <label class="form-label">Versão do Chart do Nibo WAHA</label>
      <input type="text" class="form-control" formControlName="niboWahaChartVersion" placeholder="ex: 0.1.0" />
      <div class="text-danger" *ngIf="form.get('niboWahaChartVersion')?.touched && form.get('niboWahaChartVersion')?.invalid">
        Campo obrigatório
      </div>
    </div>

    <hr />
    <h6 class="mb-2">VPA — limites de memória do WAHA (todas as conexões)</h6>
    <div class="text-muted small mb-3">
      Aceita unidades K8s (ex.: <span class="font-monospace">900Mi</span>, <span class="font-monospace">2253Mi</span>).
      Evite valores fracionários de Gi — use Mi.
    </div>

    <div class="mb-3">
      <label class="form-label">VPA minAllowed (memória)</label>
      <input type="text" class="form-control" formControlName="vpaConfigWAHAMinAllowedMemory" placeholder="ex: 900Mi" />
      <div class="text-danger" *ngIf="form.get('vpaConfigWAHAMinAllowedMemory')?.touched && form.get('vpaConfigWAHAMinAllowedMemory')?.hasError('required')">
        Campo obrigatório
      </div>
    </div>

    <div class="mb-3">
      <label class="form-label">VPA maxAllowed (memória)</label>
      <input type="text" class="form-control" formControlName="vpaConfigWAHAMaxAllowedMemory" placeholder="ex: 2253Mi" />
      <div class="text-danger" *ngIf="form.get('vpaConfigWAHAMaxAllowedMemory')?.touched && form.get('vpaConfigWAHAMaxAllowedMemory')?.hasError('required')">
        Campo obrigatório
      </div>
    </div>

    <div class="d-inline">
        <button type="button" class="btn btn-primary" (click)="openConfirmUpdateAll()" [disabled]="saving()">
          Atualizar todas as conexões
        </button>
    </div>
  </form>

  <div class="card p-3">
    <h5 class="mb-3">Padrão para novas conexões</h5>

    <div class="d-flex justify-content-center" *ngIf="defaultsLoading()">
      <app-progress-spinner class="m-auto"></app-progress-spinner>
    </div>

    <form [formGroup]="newConnectionsForm" *ngIf="!defaultsLoading()">
      <div class="mb-3">
        <label class="form-label">Imagem do WAHA</label>
        <div class="input-group">
          <select class="form-select waha-image-source" formControlName="wahaImageSource">
            <option *ngFor="let source of wahaImageSources()" [value]="source">{{ source }}</option>
          </select>
          <input type="text" class="form-control" formControlName="wahaImageTag" placeholder="latest" />
        </div>
        <div class="text-danger" *ngIf="newConnectionsForm.get('wahaImageTag')?.touched && newConnectionsForm.get('wahaImageTag')?.hasError('required')">
          Campo obrigatório
        </div>
      </div>

      <div class="mb-3">
        <label class="form-label">Imagem do Nibo WAHA</label>
        <div class="input-group">
          <span class="input-group-text">{{ niboWahaImagePrefix }}</span>
          <input type="text" class="form-control" formControlName="niboWahaImageTag" placeholder="1.2.3" />
        </div>
        <div class="text-danger" *ngIf="newConnectionsForm.get('niboWahaImageTag')?.touched && newConnectionsForm.get('niboWahaImageTag')?.hasError('required')">
          Campo obrigatório
        </div>
      </div>

      <div class="mb-3">
        <label class="form-label">Versão do Chart do Nibo WAHA</label>
        <input type="text" class="form-control" formControlName="niboWahaChartVersion" />
        <div class="text-danger" *ngIf="newConnectionsForm.get('niboWahaChartVersion')?.touched && newConnectionsForm.get('niboWahaChartVersion')?.invalid">
          Campo obrigatório
        </div>
      </div>

      <hr />
      <h6 class="mb-2">VPA — limites de memória do WAHA (padrão p/ novas conexões)</h6>
      <div class="text-muted small mb-3">
        Aceita unidades K8s (ex.: <span class="font-monospace">900Mi</span>, <span class="font-monospace">2253Mi</span>).
        Evite valores fracionários de Gi — use Mi.
      </div>

      <div class="mb-3">
        <label class="form-label">VPA minAllowed (memória)</label>
        <input type="text" class="form-control" formControlName="vpaConfigWAHAMinAllowedMemory" placeholder="ex: 900Mi" />
        <div class="text-danger" *ngIf="newConnectionsForm.get('vpaConfigWAHAMinAllowedMemory')?.touched && newConnectionsForm.get('vpaConfigWAHAMinAllowedMemory')?.hasError('required')">
          Campo obrigatório
        </div>
      </div>

      <div class="mb-3">
        <label class="form-label">VPA maxAllowed (memória)</label>
        <input type="text" class="form-control" formControlName="vpaConfigWAHAMaxAllowedMemory" placeholder="ex: 2253Mi" />
        <div class="text-danger" *ngIf="newConnectionsForm.get('vpaConfigWAHAMaxAllowedMemory')?.touched && newConnectionsForm.get('vpaConfigWAHAMaxAllowedMemory')?.hasError('required')">
          Campo obrigatório
        </div>
      </div>

      <button type="button" class="btn btn-primary" (click)="saveNewConnectionsDefaults()" [disabled]="defaultsSaving()">
        Salvar padrão
      </button>
    </form>
  </div>

  <ng-template #confirmUpdateAllModal let-modal>
    <div class="modal-header">
      <h5 class="modal-title">Confirmar atualização global</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
      <p class="mb-0">
        Esta ação irá atualizar e reiniciar <strong>todas</strong> as conexões de WhatsApp.
        Deseja continuar?
      </p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()" [disabled]="saving()">Cancelar</button>
      <button type="button" class="btn btn-danger" (click)="confirmUpdateAll(modal)" [disabled]="saving()">Confirmar</button>
    </div>
  </ng-template>
</div>
